import React from 'react'
import { RegFormWithPhone } from './RegFormWithPhone'
import { validateWithPhone } from '../ValidateWithPhone'
import { AccountRegisterContainer } from '../../../components/AccountRegisterContainer'
import { UpdateRegisterButton } from './UpdateRegisterButton'
import { Form } from '@ztechapps/webui.form'
import { routesDef } from '../../../config/routes'
import { useUpdateRegistration } from './useUpdateRegistration'
import { useError, useHistory } from '@ztechapps/common.hook'
import { useSearchParam } from 'react-use'
import { Stack } from 'react-bootstrap'
import { formatPhoneNumber, withRedirectUrl } from '@ztechapps/common.utils'

export const Page = () => {
  const [onUpdateRegistration, , { error }] = useUpdateRegistration()
  const history = useHistory()
  const userId = useSearchParam('userId')
  const redirectUrl = useSearchParam('redirect_url')
  useError(error)

  const onSubmit = async ({ phone }) => {
    await onUpdateRegistration({
      input: {
        _id: userId,
        phone: formatPhoneNumber(phone),
      },
    })
    if (error) throw error

    // Forward this session's own redirect_url so join still honors it instead of defaulting to Home.
    const nextPath = redirectUrl ? withRedirectUrl(routesDef.JoinPage.path, redirectUrl) : routesDef.JoinPage.path

    history.push(nextPath)
  }

  return (
    <AccountRegisterContainer>
      <Stack gap={3}>
        <div>
          <h4>Update registration</h4>
          <div>We need more information from you so we can properly setup your account.</div>
        </div>
        <div>
          <Form initialValues={{ phone: '' }} validate={validateWithPhone} onSubmit={onSubmit}>
            <Stack gap={2}>
              <RegFormWithPhone />
              <div>
                <UpdateRegisterButton />
              </div>
            </Stack>
          </Form>
        </div>
      </Stack>
    </AccountRegisterContainer>
  )
}
